module.exports = __webpack_public_path__ + "img/1.3893477d.png";